import * as fromDatatype from '../datatype-library';

export interface bl_fi_entity_credit_term_hdr_RowInterface{
    guid : fromDatatype.GuidDataFieldInterface;
    code : fromDatatype.VarcharDatatypeInterface;
    name : fromDatatype.VarcharDatatypeInterface;
    decsr : fromDatatype.VarcharDatatypeInterface;
    set_year : fromDatatype.IntegerDatatypeInterface;
    set_month : fromDatatype.IntegerDatatypeInterface;
    set_day : fromDatatype.IntegerDatatypeInterface;
    add_year : fromDatatype.IntegerDatatypeInterface;
    add_month : fromDatatype.IntegerDatatypeInterface;
    add_day : fromDatatype.IntegerDatatypeInterface;
    created_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    status : fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
	applet_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
    credit_term_logic: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_entity_credit_term_hdr_RowClass implements bl_fi_entity_credit_term_hdr_RowInterface {

    guid : fromDatatype.GuidDataFieldInterface;
    code : fromDatatype.VarcharDatatypeInterface;
    name : fromDatatype.VarcharDatatypeInterface;
    decsr : fromDatatype.VarcharDatatypeInterface;
    set_year : fromDatatype.IntegerDatatypeInterface;
    set_month : fromDatatype.IntegerDatatypeInterface;
    set_day : fromDatatype.IntegerDatatypeInterface;
    add_year : fromDatatype.IntegerDatatypeInterface;
    add_month : fromDatatype.IntegerDatatypeInterface;
    add_day : fromDatatype.IntegerDatatypeInterface;
    created_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    status : fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
	applet_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
    credit_term_logic: fromDatatype.VarcharDatatypeInterface;
}

